import React, { useContext } from 'react'
import { ContentHeader } from '../../layout/Content'
import { customerCreditAccountControllerContext } from './CustomerCreditAccountController'
import CustomerCreditAccountHeaderStyle from './css/CustomerCreditAccountHeaderStyle'

function CustomerCreditAccountHeader() {
  const customerCreditAccountController = useContext(customerCreditAccountControllerContext)
  const { customerAccount } = customerCreditAccountController

  return (
    <ContentHeader>
      <div className='customer-details-title-container'>
        <div className='header-title customer-details-title'>
          {
            (customerAccount) ?
            `${customerAccount._id.toUpperCase()}, ${customerAccount.customer_details.account_name} Credit Account Details`
            : null
          }
        </div>
      </div>
      <CustomerCreditAccountHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(CustomerCreditAccountHeader)
